import React from "react";

export const PresentationStyle = {
  TILE: "TILE",
  LIST: "LIST",
  GALLERY: "GALLERY",
  SMART: "SMART",
  TEMPLATE: "SHOP_DESIGN",
} as const;

export type PresentationStyleType = typeof PresentationStyle[keyof typeof PresentationStyle];

export type PresentationStyleOption = {
  value: PresentationStyleType;
  Component: () => React.JSX.Element;
};

export type TemplateOption = {
  label: string;
  value: string;
};

export interface GroupedOption {
  label: string;
  options: TemplateOption[];
};